import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as actions from '../../store/actions';
import { history } from '../../index';
import { isCookieExpired, isInterviewDeveloper } from '../../helperFunctions';
import MeetingContainer from './Meeting/MeetingContainer';
import Spinner from '../../components/UI/Spinner/Spinner';

const BaseInterviewContainer = ({ location, endInterview }) => {
  const dispatch = useDispatch();

  // Redux state selectors
  const interview_id_from_store = useSelector(state => state.interview.interview_id);
  const interview_status = useSelector(state => state.interview.status);
  const participants = useSelector(state => state.interview.participants);
  const last_language = useSelector(state => state.events.last_language);
  const meeting_id = useSelector(state => state.meeting.id);

  // Local state
  const [isDataLoaded, setIsDataLoaded] = useState(false);
  const [isIntervieweeFlow, setIsIntervieweeFlow] = useState(false);

  useEffect(() => {
    const urlparams = new URLSearchParams(location.search);
    const interview_id = urlparams.get('interview_id');
    console.log('Component mounted', interview_id);

    const token = localStorage.getItem('access-token');
    const hash_value = localStorage.getItem('hash_value');
    const role = localStorage.getItem('role');
    const company_id = localStorage.getItem('company_id');

    // Redirect if missing credentials or cookie expired
    if (!token || isCookieExpired()) {
      history.push(
        `/interviewinvite?invterview_id=${interview_id}&hash_value=${hash_value}&role=${role}&company_id=${company_id}`,
      );
      return;
    }

    const fetchInterviewData = async () => {
      if (!interview_status) {
        await dispatch(
          actions.fetchInterviewInvite(interview_id, hash_value, role, company_id, true),
        );

        // After fetching, check interview completion and feedback
        const updatedStatus = interview_status; // might still be stale, optional refetch
        if (updatedStatus === 'COMPLETED' || updatedStatus === 'CM') {
          const curr_participant = participants.find(
            p => p.email === localStorage.getItem('username'),
          );
          if (
            curr_participant?.role === 'IN' &&
            (!curr_participant.feedback || !curr_participant.rating)
          ) {
            history.push(`/interview/feedback?interview_id=${interview_id}`);
            return;
          }
        }

        // Create or get meeting if developer
        if (isInterviewDeveloper(participants)) {
          dispatch(actions.createMeeting(interview_id));
        }
      } else {
        // Data already exists, just create meeting if needed
        if (isInterviewDeveloper(participants)) {
          dispatch(actions.createMeeting(interview_id));
        }
      }

      // Common data fetching
      dispatch(actions.fetchData(interview_id));
      dispatch(actions.getLanguages());
    };

    fetchInterviewData();
  }, [dispatch, interview_status, participants, last_language, location.search]);

  useEffect(() => {
    const email_id = localStorage.getItem('username');

    if (meeting_id && email_id) {
      const participant = participants.find(p => p.email === email_id);
      if (participant) {
        dispatch(actions.fetchAttendee(meeting_id, participant.id))
          .then(() => setIsDataLoaded(true))
          .catch(() => setIsDataLoaded(false));
      }
    } else if (!isInterviewDeveloper(participants) && !isIntervieweeFlow) {
      // Interviewee flow setup
      setIsIntervieweeFlow(true);
    }
  }, [meeting_id, participants, dispatch, isIntervieweeFlow]);

  return (
    <>
      {isDataLoaded || isIntervieweeFlow ? (
        <MeetingContainer endInterview={endInterview} />
      ) : (
        <Spinner />
      )}
    </>
  );
};

export default BaseInterviewContainer;
